module.exports = __webpack_public_path__ + "static/img/facttic.cc3e46e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/facttic.svg
// module id = +ZkL
// module chunks = 1